import type { MountDeckPlayerWidgetHandle, MountDeckPlayerWidgetOptions } from '../integration'
import { mountDeckPlayerWidget } from '../integration'
import { DeckPlayerWidgetProgressBar } from '../widgets/components'

const DISPLAY_NAME = 'deckplayer-progress'
const DEFAULT_SELECTOR = '[data-deckplayer-widget="deckplayer-progress"]'

export function mountDeckPlayerProgressWidget(
  target: string | Element = DEFAULT_SELECTOR,
  opts: Omit<MountDeckPlayerWidgetOptions, 'displayName'> = {},
): Promise<MountDeckPlayerWidgetHandle> {
  return mountDeckPlayerWidget(target, DeckPlayerWidgetProgressBar, {
    ...opts,
    displayName: DISPLAY_NAME,
  })
}
